"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * The UserStore is deprecated and unsafe to use for any component that renders server side.
 *
 * Please see the user_context_provider as a replacement.
 * commons/src/components/user_context_provider.tsx
 * Docs: https://github.com/reverbdotcom/docs/blob/master/tech/user-context-provider.md
 */
var alt_1 = require("../components/alt");
var user_actions_1 = require("./user_actions");
var deprecate_1 = require("../deprecate");
var constants_1 = require("../components/shared/constants");
var user_context_helpers_1 = require("@reverbdotcom/commons/dist/user_context_helpers");
var UserStore = /** @class */ (function (_super) {
    tslib_1.__extends(UserStore, _super);
    function UserStore() {
        var _this = _super.call(this) || this;
        _this.email = null;
        _this.name = null;
        _this.country = null;
        _this.id = null;
        _this.isAdmin = false;
        _this.isActivated = true;
        _this.isBusiness = false;
        _this.preferredSeller = false;
        _this.isBot = false;
        _this.loggedOut = true;
        _this.cookieId = null;
        _this.requestId = null;
        _this.countryCode = null;
        _this.shippingRegionCode = null;
        _this.profileSlug = null;
        _this.gdpr = false;
        _this.deviceName = null;
        _this.experiments = [];
        _this.locale = null;
        _this.currency = null;
        _this.bindActions(user_actions_1.default);
        _this.exportPublicMethods({
            isExperimentEnabled: _this.isExperimentEnabled.bind(_this),
            experimentBucket: _this.experimentBucket.bind(_this),
            fiveDigitLocale: _this.fiveDigitLocale.bind(_this),
        });
        return _this;
    }
    UserStore.prototype.onSetUser = function (user) {
        this.setState(user);
    };
    UserStore.prototype.isExperimentEnabled = function (name) {
        return user_context_helpers_1.isExperimentEnabled(this, name);
    };
    UserStore.prototype.experimentBucket = function (name) {
        return user_context_helpers_1.experimentBucket(this, name);
    };
    UserStore.prototype.fiveDigitLocale = function () {
        if (this.shippingRegionCode === constants_1.EVERYWHERE_CODE) {
            return this.locale;
        }
        var countryCode = this.shippingRegionCode;
        if (countryCode.length > 2) {
            countryCode = this.shippingRegionCode.substring(0, 2);
        }
        return this.locale + "-" + countryCode;
    };
    tslib_1.__decorate([
        deprecate_1.deprecated('UserStore is deprecated, please use the UserContextProvider')
    ], UserStore.prototype, "isExperimentEnabled", null);
    tslib_1.__decorate([
        deprecate_1.deprecated('UserStore is deprecated, please use the UserContextProvider')
    ], UserStore.prototype, "experimentBucket", null);
    tslib_1.__decorate([
        deprecate_1.deprecated('UserStore is deprecated, please use the UserContextProvider')
    ], UserStore.prototype, "fiveDigitLocale", null);
    return UserStore;
}(alt_1.AltStoreModel));
exports.default = alt_1.default.createStore(UserStore, 'UserStore');
//# sourceMappingURL=user_store.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/user_store.js
// module id = DlZJ
// module chunks = 20 21 22